import React from 'react';
import { useAppSelector } from '../../store/hooks';
import { FiAlertTriangle } from 'react-icons/fi';

interface AdminConfirmModalProps {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  destructive?: boolean;
}

const AdminConfirmModal: React.FC<AdminConfirmModalProps> = ({
  title, message, confirmLabel = 'Confirm', onConfirm, onCancel, destructive = false,
}) => {
  const colors = useAppSelector((state) => state.theme.theme);
  const btnColor = destructive ? colors.alertColor : colors.primary;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-[100] p-4"
      style={{ backgroundColor: colors.modalBackground }}
    >
      <div
        className="rounded-2xl p-6 w-full max-w-sm"
        style={{ backgroundColor: colors.cardBackground || colors.backgroundColor, boxShadow: colors.shadowLarge }}
      >
        <div className="text-center mb-5">
          <div
            className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-3"
            style={{ backgroundColor: `${btnColor}20` }}
          >
            {React.createElement(FiAlertTriangle as any, { size: 24, color: btnColor })}
          </div>
          <h3 className="text-lg font-bold" style={{ color: colors.textColor }}>{title}</h3>
          <p className="text-sm mt-2" style={{ color: colors.grayScale500 }}>{message}</p>
        </div>
        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 py-2.5 rounded-xl border text-sm font-medium"
            style={{ borderColor: colors.borderColor, color: colors.textColor }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="flex-1 py-2.5 rounded-xl text-sm font-medium text-white"
            style={{ backgroundColor: btnColor }}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminConfirmModal;
